import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-help',
  templateUrl: './help.page.html',
  styleUrls: ['./help.page.scss'],
})
export class HelpPage implements OnInit {

  constructor() { }

  ngOnInit() { }

  ionViewWillEnter() {

  }

}
